import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DailyTicketCount, LocationStateModel, LocationVm, StatisticsLocation } from './model';
import { fetchDailyTickets, fetchStatistics, fetchStructure } from './operations';

const initialState = {
  locations: [] as LocationVm[],
} as LocationStateModel;

const locationSlice = createSlice({
  name: 'location',
  initialState: initialState,
  reducers: {
    fetchedStructure(state, action: PayloadAction<LocationVm[]>) {
      state.locations = action.payload;
    },
    setSelectedHeadLocation(state, action: PayloadAction<string>) {
      state.selectedHeadLocationUuid = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchStructure.fulfilled, (state, action: PayloadAction<LocationVm[]>) => {
      state.locations = action.payload;
      const selectionStillValid =
        !!state.selectedHeadLocationUuid && action.payload.some((l) => l.uuid === state.selectedHeadLocationUuid);
      if (!selectionStillValid) {
        state.selectedHeadLocationUuid = action.payload.length > 0 ? action.payload[0].uuid : '';
      }
    });
    builder.addCase(fetchStatistics.fulfilled, (state, action: PayloadAction<StatisticsLocation[]>) => {
      console.log(action.payload);
      state.statistics = action.payload;
    });
    builder.addCase(fetchDailyTickets.fulfilled, (state, action: PayloadAction<DailyTicketCount[]>) => {
      state.dailyTickets = action.payload;
    });
  },
});

export const { setSelectedHeadLocation } = locationSlice.actions;

export default locationSlice.reducer;
